import { Menu } from '@mui/material';
import { FC, useState } from 'react';
import { usePatientProfilePage } from '../../hooks';
import { PatientProfileRoutePath, RouteConfig, RouteConfigItem } from '../route-config';
import { BackButton, DropdownMenuItem, NavbarMenu, NavbarMenuItem, NavbarWrapper } from './navbar.styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { usePatientProfile } from '../../../../../../hooks/use-patient-profile';

export const Navbar: FC = () => {
  const { goTo, route } = usePatientProfilePage();
  const { showFormsForPatient } = usePatientProfile();
  const filteredRouteConfig = showFormsForPatient ? RouteConfig : RouteConfig.filter(r => r.path !== PatientProfileRoutePath.FORMS);
  const [visibleItems] = useState<RouteConfigItem[]>(filteredRouteConfig.slice(0, 5));
  const [dropdownItems] = useState<RouteConfigItem[]>(filteredRouteConfig.slice(5, filteredRouteConfig.length));
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMoreClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const displayBackToOverview = dropdownItems.some((item) => item.path === route);

  if (displayBackToOverview) {
    return (
      <NavbarWrapper>
        <BackButton onClick={() => goTo(PatientProfileRoutePath.OVERVIEW)} startIcon={<ArrowBackIcon />}>
          Back to Overview
        </BackButton>
      </NavbarWrapper>
    );
  }

  return (
    <NavbarWrapper>
      <NavbarMenu>
        {visibleItems.map((item, index) => (
          <NavbarMenuItem
            key={index}
            onClick={() => goTo(item.path)}
            className={`patient-profile-navbar-item ${item.path == route ? 'selected' : ''}`}
          >
            {item.name}
          </NavbarMenuItem>
        ))}
        <NavbarMenuItem key={filteredRouteConfig.length + 1} onClick={handleMoreClick}>
          More
        </NavbarMenuItem>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{ sx: { backgroundColor: 'white' } }}
        >
          {dropdownItems.map((item, index) => (
            <DropdownMenuItem className="patient-profile-navbar-item" key={index} onClick={() => goTo(item.path)}>
              {item.name}
            </DropdownMenuItem>
          ))}
        </Menu>
      </NavbarMenu>
    </NavbarWrapper>
  );
};
